import { useIntl } from 'react-intl';
import router from 'next/router';
import { useSWRConfig } from 'swr';
import { useLoginApi } from './LoginApi';

export const useLogout = () => {
  const { locale } = useIntl();
  const loginApi = useLoginApi();
  const { mutate } = useSWRConfig();

  const logout = async () => {
    const { apiKeyManager } = await import('@empiriecom/mybuy-session');
    if (loginApi) {
      try {
        const response = await loginApi!.logout({ ecLocale: locale });
        await apiKeyManager.logout(response);
        router.push('/');
      } catch (e) {
        await apiKeyManager.logout();
        router.push('/');
      } finally {
        mutate('session');
      }
    } else {
      throw new Error('tried to access loginApi before it was initialized');
    }
  };

  return {
    logout,
  };
};
